module.exports = __webpack_public_path__ + "76ac928e6b3e55a664dcd44cb8bd49f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/objekte/Ruoff_140227_0019_a - 441KB.jpg
// module id = 365
// module chunks = 0